import PageSymphony from "elements/PageSymphony";
import SuccessCampaign from "./CampaignViews/SuccessCampaign";

/**
 * Component for displaying campaign submission success or handling checkout redirect
 * Supports two scenarios:
 * 1. Display success page when campaign is created (for users on paid plan)
 * 2. Handle redirect from Stripe checkout after payment completed
 */
const CampaignSubmissionView = () => {
    return (
        <PageSymphony
            className="campaignViewPage"
            isContent
            isCard
        >
            <SuccessCampaign />
        </PageSymphony>
    );
};

export default CampaignSubmissionView;